import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AttachmentsComponent } from './attachments.component';
import { FilesViewerModalModule } from '@app/shared/components/files-viewer-modal/files-viewer-modal.module';

@NgModule({
  declarations: [AttachmentsComponent],
  exports: [AttachmentsComponent],
  imports: [CommonModule, FilesViewerModalModule],
})
export class AttachmentsModule {}
